import './map.scss';

import { GoogleMap, InfoWindow, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';
import React, { Component } from 'react';

import Autocomplete from 'react-google-autocomplete';
import Geocode from 'react-geocode';
import { GoogleMapsAPI } from '../client-config';
import { images } from 'src/assets/img';
import searchIcon from 'src/assets/img/SalesForce_Icon/SearchIcon.svg';

Geocode.setApiKey('AIzaSyCv0JT6W6tMYCww1FnEjf6CxaKUFIhbNdA');
Geocode.enableDebug();

class Map extends Component {
	constructor(props) {
		super(props);
		this.state = {
			address: '',
		};
	}

	componentDidMount() {
		this.setState({ address: this.props.address });
	}
	render() {
		const AsyncMap = withScriptjs(
			withGoogleMap((props) => (
				<GoogleMap
					google={this.props.google}
					defaultZoom={this.props.zoom}
					defaultCenter={{
						lat: this.props.mapPosition.lat,
						lng: this.props.mapPosition.lng,
					}}>
					{/* InfoWindow on top of marker */}
					{this.props.address
						? null
						: // <InfoWindow
						  // 	onClose={this.onInfoWindowClose}
						  // 	position={{
						  // 		lat: this.props.markerPosition.lat + 0.0018,
						  // 		lng: this.props.markerPosition.lng,
						  // 	}}>
						  // 	<div>
						  // 		{' '}
						  // 		<span style={{ padding: 0, margin: 0 }}>{this.state.address}</span>
						  // 	</div>
						  // </InfoWindow>
						  null}

					{/*Marker*/}
					<Marker
						// google={this.props.google}
						// name={'Dolores park'}
						draggable={true}
						onDragEnd={this.props.onMarkerDragEnd}
						position={{
							lat: this.props.markerPosition.lat,
							lng: this.props.markerPosition.lng,
						}}
					/>
					<Marker />
					{/* For Auto complete Search Box */}
					<img style={{ position: 'absolute', top: '-44px', left: '2px', width: '30px' }} src={searchIcon}></img>
					<Autocomplete
						style={{
							width: '100%',
							height: '40px',
							paddingLeft: '16px',
							marginTop: '-50px',
							// marginBottom: '500px',
							position: 'absolute',
							paddingLeft: '30px',
							top: 0,
							outline: 'none',
						}}
						className="search-emirate"
						onPlaceSelected={this.props.onPlaceSelected}
						// types={['(regions)']}
						placeholder={this.props.address ? this.props.address : 'Search'}
						language="en"
						options={{
							// types: ['(regions)'],
							types: ['geocode', 'establishment'],
							componentRestrictions: { country: 'AE' },
							fields: [
								'address_components',
								'adr_address',
								'geometry.location',
								'place_id',
								'formatted_address',
								'business_status',
								'formatted_phone_number',
								'international_phone_number',
								'name',
							],
						}}
						inputAutocompleteValue={this.props.address}
						defaultValue={this.props.address}></Autocomplete>
				</GoogleMap>
			))
		);
		let map;
		if (this.props.lat !== undefined) {
			map = (
				<>
					<div>
						<AsyncMap
							googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GoogleMapsAPI}&libraries=places`}
							loadingElement={<div style={{ height: this.props.height }}>Loading..</div>}
							containerElement={<div style={{ height: this.props.height }} />}
							mapElement={<div style={{ height: `100%` }} />}
						/>
					</div>
					<div className="use_my_location_container" onClick={this.props.getMyLocation}>
						<img style={{ marginTop: '2px', width: '25px', height: '25px', cursor: 'pointer' }} src={images.location} />
						<text className="locationtext">Use my current location</text>
					</div>
				</>
			);
		} else {
			map = <div style={{ height: this.props.height }} />;
		}
		return map;
	}
}
export default Map;
